export const Aetheryte = {
    "Central Shroud": {
        "Bentbranch Meadows": [21.7, 22.2]
    },
    "East Shroud": {
        "The Hawthorne Hut": [17.7, 27.4]
    },
    "South Shroud": {
        "Quarrymill": [25,20.1],
        "Camp Tranquil": [16.8, 28.5],
    },
    "North Shroud": {
        "Fallgourd Float": [20.6, 26.1]
    },
    "Western Thanalan": {
        "Horizon": [22.8,16.9],
    },
    "Central Thanalan": {
        "Black Brush Station": [21.1, 18.1],
    },
    "Eastern Thanalan": {
        "Camp Drybone": [13.7, 24.3],
    },
    "Southern Thanalan": {
        "Little Ala Mhigo": [18.2, 13.1],
        "Forgotten Springs": [14.9, 29.6],
    },
    "Northern Thanalan": {
        "Camp Bluefog": [21.8, 30.5],
        "Ceruleum Processing Plant": [20.9, 20.8],
    },
    "Middle La Noscea": {
        "Summerford Farms": [26, 16.3],
    },
    "Lower La Noscea": {
        "Moraby Drydocks": [24.6, 34.9],
    },
    "Eastern La Noscea": {
        "Costa del Sol": [31.2, 30.8],
        "Wineport": [21.0, 21.5],
    },
    "Western La Noscea": {
        "Swiftperch": [34.5, 31.7],
        "Aleport": [26.7, 25.8],
    },
    "Upper La Noscea": {
        "Camp Bronze Lake": [30.2, 23.3],
    },
    "Outer La Noscea": {
        "Camp Overlook": [19.1, 17.2],
    },
    "Coerthas Central Highlands": {
        "Camp Dragonhead": [25.9, 16.8],
    },
    "Mor Dhona": {
        "Revenant's Toll": [22.2, 8.1],
    },
    "Coerthas Western Highlands": {
        "Falcon's Nest": [32, 36.7],
    },
    "The Dravanian Forelands": {
        "Tailfeather": [33.2, 23.1],
        "Anyx Trine": [16.4, 23.2]
    },
    "The Churning Mists": {
        "Moghome": [27.7, 34.4],
        "Zenith": [10.8, 28.8],
    },
    "The Dravanian Hinterlands": {},
    "The Sea of Clouds": {
        "Camp Cloudtop": [10.2, 33.4],
        "Ok' Zundu": [10.3, 14.2]
    },
    "Azys Lla": {
        "Helix": [8, 10.6],
    },
    "The Fringes": {
        "Castrum Oriens": [8.8, 11.2],
        "The Peering Stones": [29.8, 26.4]
    },
    "The Peaks": {
        "Ala Ghiri": [16.0, 36.3],
        "Ala Gannha": [23.6, 6.8]
    },
    "The Lochs": {
        "Porta Praetoria": [8.4, 20.9],
        "The Ala Mhigan Quarter": [33.7, 34.5]
    },
    "The Ruby Sea": {
        "Tamamizu": [28.6, 16.3],
        "Onokoro": [23.2, 9.7]
    },
    "Yanxia": {
        "Namai": [30.1, 19.7],
        "The House of the Fierce": [26.3, 13.4]
    },
    "The Azim Steppe": {
        "Reunion": [32.5, 28.2],
        "The Dawn Throne": [23, 22.1],
        "Dhoro Iloh": [6.3, 23.7]
    },
    "Lakeland": {
        "Fort Jobb": [36.5, 20.9],
        "The Ostall Imperative": [6.7, 16.9]
    },
    "Kholusia": {
        "Stilltide": [34.8, 27.2],
        "Wright": [16.5, 29.2],
        "Tomra": [12.9, 8.9]
    },
    "Amh Araeng": {
        "Mord Souq": [26.3, 17],
        "The Inn at Journey's Head": [29.4, 27.6],
        "Twine": [11.2, 17.2]
    },
    "Il Mheg": {
        "Lydha Lran": [14.5, 31.7],
        "Pla Enni": [20, 4.3],
        "Wolekdorf": [29.1, 7.8]
    },
    "The Rak'tika Greatwood": {
        "Fanow": [29.0, 17.6],
        "Slitherbough": [19.4, 27.4]
    },
    "The Tempest": {
        "The Ondo Cups": [32.7, 17.4],
        "The Macarenses Angle": [18.6, 25.8]
    },
    "Labyrinthos": {
        "The Archeion": [30.3, 11.8],
        "Sharlayan Hamlet": [21.6, 20.5],
        "Aporia": [6.9, 27.5]
    },
    "Thavnair": {
        "Palaka's Stand": [29.7, 16.6],
        "The Great Work": [10.9, 22.2],
        "Yedlihmad": [25.3, 34]
    },
    "Garlemald": {
        "Tertium": [31.8, 17.9],
        "Camp Broken Glass": [13.2, 31.1]
    },
    "Mare Lamentorum": {
        "Bestways Burrow": [21.4, 11.2],
        "Sinus Lacrimarum": [10.1, 34.4]
    },
    "Elpis": {
        "Anagnorisis": [24.6, 24],
        "The Twelve Wonders": [8.7, 32.2],
        "Poieten Oikos": [10.8, 16.9]
    },
    "Ultima Thule": {
        "Abode of the Ea": [22.7, 8.3],
        "Reah Tahra": [10.6, 26.8]
    },
    "Urqopacha": {
        
    },
    "Kozama'uka": {
        
    },
    "Yak T'el": {
        
    },
    "Shaaloani": {
        
    },
    "Heritage Found": {
        
    },
    "Living Memory": {
        
    }
};